import { IEnvironment } from '@nimbus-library/features/configuration/i-environment.service';
import { ApplicationType } from '@nimbus-library/features/configuration/application-type.enum';

export const environment: IEnvironment = {
  production: true,
  applicationType: ApplicationType.Assistant,
};
